
export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 200
        },
        color: {
            type: Number,
            default: 0xFFFFFF
        },
        alpha: {
            type: Number,
            default: 1
        },
        radius: {
            type: Number,
            default: 10
        },
        zIndex: {
            type: Number
        },
        interactive: {
            type: Boolean,
            default: false
        },
        anchorX: {
            type: Number,
            default: 0.5
        },
        anchorY: {
            type: Number,
            default: 0.5
        },
        pointer: {
            type: Boolean,
            default: false
        },
        border: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            graphics: null,
            container: null
        };
    },

    watch: {
        alpha () {
            this.graphics.alpha = this.alpha;
        },
        x () {
            this.graphics.x = this.x;
        },
        y () {
            this.graphics.y = this.y;
        },
        width () {
            this.graphics.width = this.width;
            this.drawRect();
        },
        height () {
            this.graphics.height = this.height;
            this.drawRect();
        },
        interactive () {
            this.graphics.interactive = this.interactive;
        },
        color () {
            this.drawRect();
        }
    },

    created () {
        this.container = this.$game.getParentPIXIContainer(this);
        this.PIXIWrapper.LoaderManager.add(this, this.draw);
    },

    destroyed () {
        if (this.graphics !== null && !this.graphics._destroyed) {
            this.graphics.destroy(true);
        }
    },

    methods: {
        /**
         * Draw the container.
         */
        draw () {
            this.graphics = new this.PIXIWrapper.PIXI.Graphics();

            this.drawRect();

            this.graphics.alpha = this.alpha;

            if (this.pointer) {
                this.graphics.cursor = 'pointer';
            }

            if (this.zIndex !== undefined) {
                this.graphics.zIndex = this.zIndex;
            }

            if (this.interactive) {
                this.defineEvents();
            }

            // Add the graphic to the parent container or the root app stage.
            if (this.container) {
                this.container.addChild(this.graphics);
            } else {
                this.PIXIWrapper.app.stage.addChild(this.graphics);
            }
        },

        /**
         * Draw the button.
         */
        drawRect () {
            this.graphics.clear();

            if (this.border) {
                this.graphics.beginFill(this.color, 0);
                this.graphics.lineStyle(3, this.color, 1, 0.5, false);
            } else {
                this.graphics.beginFill(this.color);
            }

            this.graphics.drawRoundedRect(
                -this.width / 2,
                -this.height / 2,
                this.width,
                this.height,
                this.radius
            );

            if (this.anchorX === 0.5) {
                this.graphics.x = this.x;
            } else if (this.anchorX === 0) {
                this.graphics.x = this.x + this.width / 2;
            } else if (this.anchorX === 1) {
                this.graphics.x = this.x - this.width / 2;
            }

            if (this.anchorY === 0.5) {
                this.graphics.y = this.y;
            } else if (this.anchorY === 0) {
                this.graphics.y = this.y + this.height / 2;
            } else if (this.anchorY === 1) {
                this.graphics.y = this.y - this.height / 2;
            }


            this.graphics.width = this.width;
            this.graphics.height = this.height;

            this.graphics.endFill();
        },

        /**
         * Define all pixi events that should be emitted ($emit) to the parent component.
         * Only events that are used in parent component ($listeners) will be attached.
         */
        defineEvents () {
            let eventList = [
                'added',
                'click',
                'mousedown',
                'mousemove',
                'mouseout',
                'mouseover',
                'mouseup',
                'mouseupoutside',
                'pointercancel',
                'pointerdown',
                'pointermove',
                'pointerout',
                'pointerover',
                'pointertap',
                'pointerup',
                'pointerupoutside',
                'removed',
                'rightclick',
                'rightdown',
                'rightup',
                'rightupoutside',
                'tap',
                'touchcancel',
                'touchend',
                'touchendoutside',
                'touchmove',
                'touchstart'
            ];

            this.graphics.interactive = true;

            eventList
                .filter(eventName => Object.keys(this.$listeners).includes(eventName))
                .forEach(eventName => {
                    this.graphics.on(eventName, (event) => {
                        this.$emit(eventName, {
                            element: this.graphics,
                            event,
                            AnimationManager: this.PIXIWrapper.AnimationManager
                        });
                    });
                });
        }
    },

    render (h) {
        return h('template', this.$slots.default);
    }
};
